import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Category Card",
  category: "layouts",
  icon: "admin-links",
  description: "A card representing a category or genre",
  keywords: ["category", "genre", "tile"],
}

export default defineBlock("hero/category-card-item", (props) => {
  return (
    <Link
      href={props.url}
      draggable={false}
      className="group/card text-fg bg-bg-mid type-title-l h-[5em] p-4 flex flex-col transition-colors duration-400 is-theme-dark:hover:bg-neutral-700 isolate"
      as={env.admin ? "div" : undefined}
    >
      {props.image && (
        <div className="absolute inset-0 z-0 is-theme-dark:[filter:contrast(0.9)_brightness(0.5)] transition-[filter] group-hover/card:[filter:contrast(0.9)_brightness(0.7)]">
          <ResponsiveImage max objectFit="cover" objectPosition="center" {...props.image} />
        </div>
      )}
      <EditableText
        store="title"
        as="div"
        className="text-fg relative z-10"
        defaultValue="Enter a title"
        plainText
        appendOnEnter="hero/category-card-item"
      />
    </Link>
  )
})
